import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { formatDate } from '@applyboard/ui-utils';
import { format } from 'date-fns';
export function convertTimelessDateStrToLocalDate(str) {
  var _str$split = str.split('-'),
    _str$split2 = _slicedToArray(_str$split, 3),
    year = _str$split2[0],
    month = _str$split2[1],
    day = _str$split2[2];
  return new Date(Number(year), Number(month) - 1, Number(day), 12, 0, 0, 0);
}

/**
 * Formats a timeless date string, using the current user's local timezone
 *
 * @param str The date string to format (e.g. 2023-01-01)
 * @param format The moment.js format string to use
 * @returns A formatted date
 */
export function formatTimelessDateStr(str, format) {
  return formatDate(convertTimelessDateStrToLocalDate(str), format);
}

/**
 * Gets a local timeless date string, given an ISO date
 *
 * This is different from simply stripping off the time portion of the ISO date,
 * since we need to make sure we return the correct string based on the user's
 * local timezone.  Just stripping off the time portion will not always give the
 * correct result
 */
export function getLocalTimelessDateStrFromISOStr(str) {
  return format(new Date(str), 'yyyy-MM-dd');
}

/**
 * Converts an ISO 8601 date string with timezone (e.g., "2025-10-01T03:59:59Z") into a formatted string: "YYYY-MM-DD HH:MM A/PM TZ".
 *
 * @param {string} isoDateString - The input date in ISO 8601 format (e.g., "2025-10-01T03:59:59Z").
 * @returns {string} - The formatted date string in "YYYY-MM-DD HH:MM A/PM TZ" format.
 */
export var formatDateWithTimezone = function formatDateWithTimezone(isoDateString) {
  var date = new Date(isoDateString);
  return format(date, 'yyyy-MM-dd hh:mm a z');
};

/**
 * Formats a deadline, including the timezone information
 *
 * @example April 2, 2025 at 10:02 AM (Eastern Daylight Time)
 */
export function formatDetailedDeadline(deadline) {
  var _Intl$DateTimeFormat$;
  var date = new Date(deadline);
  var datePart = date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
  var timeZoneName = (_Intl$DateTimeFormat$ = new Intl.DateTimeFormat('en-US', {
    timeZoneName: 'long'
  }).formatToParts(date).find(function (part) {
    return part.type === 'timeZoneName';
  })) === null || _Intl$DateTimeFormat$ === void 0 ? void 0 : _Intl$DateTimeFormat$.value;
  return "".concat(datePart, " (").concat(timeZoneName, ")");
}